import Model from "./model";

class AsigProject extends Model {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this._serviceAccountId;
    this._asigProjectId;
  }
  /* eslint-enable */

  get serviceAccountId() {
    return this._serviceAccountId;
  }

  set serviceAccountId(value) {
    this._serviceAccountId = value;
  }

  get asigProjectId() {
    return this._asigProjectId;
  }

  set asigProjectId(value) {
    this._asigProjectId = value;
  }

  json() {
    return {
      serviceAccountId: this._serviceAccountId,
      asigProjectId: this._asigProjectId,
    };
  }
}

export default AsigProject;
